import * as React from "react";
/* empty css                   */
const SkipToMapLink = ({ onClick, text, href, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: "locations-skip-to-map-link" }, /* @__PURE__ */ React.createElement("a", { onClick, href, className: "locations-skip-to-map-link__link" }, text));
export {
  SkipToMapLink as default
};
//# sourceMappingURL=SkipToMapLink.js.map
